import { render } from "./chooseStore.vue?vue&type=template&id=5024bc00&scoped=true"
import script from "./chooseStore.vue?vue&type=script&lang=js"
export * from "./chooseStore.vue?vue&type=script&lang=js"

import "./chooseStore.vue?vue&type=style&index=0&id=5024bc00&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/pre__cosmic-mall-h5-entry/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5024bc00"]])

export default __exports__